import {
  GENERAL_GROUP_VISA_SERVICE,
  SPAIN_GROUP_VISA_SERVICE,
} from "@/components/program-manager/sessions/constants.js";
import {
  GROUP_VISA_ALLOWED_COUNTRIES,
  GV_ALLOWED_COUNTIES_NEW_JERSEY,
  GV_ALLOWED_STATES_ITALY,
  GV_ALLOWED_STATES_SPAIN,
  GV_ALLOWED_STATES_SPAIN_2,
} from "@/constants.js";

const isGroupVisaEligible = (profile, session) => {
  const visaProductIds = new Set([GENERAL_GROUP_VISA_SERVICE.id, SPAIN_GROUP_VISA_SERVICE.id]);
  const sessionProducts = new Set((session?.available_products ?? []).map((product) => product?.id));

  if (visaProductIds.intersection(sessionProducts).size < 1) {
    return false;
  }

  const userCurrentCountry = profile?.current_address_country_id;
  const userPermanentCountry = profile?.permanent_address_country_id;
  const userCountries = new Set([userCurrentCountry, userPermanentCountry]);

  const userCurrentCounty = profile?.current_address_administrative_area_level_2;
  const userPermanentCounty = profile?.permanent_address_administrative_area_level_2;
  const userCounties = new Set([userCurrentCounty, userPermanentCounty]);

  const userCurrentState = profile?.current_address_state;
  const userPermanentState = profile?.permanent_address_state;
  const userStates = new Set([userCurrentState, userPermanentState]);

  const sessionTravelDetails = session?.session_travel_details?.[0];
  const sessionCountry = sessionTravelDetails?.arrival_city?.country?.id;

  const newJerseyCounties = new Set(GV_ALLOWED_COUNTIES_NEW_JERSEY);

  const groupVisaAllowedStatesForSpain = new Set([...GV_ALLOWED_STATES_SPAIN, ...GV_ALLOWED_STATES_SPAIN_2]);

  // student is from New Jersey county list and is traveling to Italy
  if (
    [userCurrentState, userPermanentState].includes("New Jersey") &&
    newJerseyCounties.intersection(userCounties).size > 0 &&
    sessionCountry == "IT"
  ) {
    return true;
  }

  if (GROUP_VISA_ALLOWED_COUNTRIES.includes(sessionCountry)) {
    if (sessionCountry == "IT" && new Set(GV_ALLOWED_STATES_ITALY).intersection(userStates).size > 0) {
      return true;
    }

    if (sessionCountry == "ES" && groupVisaAllowedStatesForSpain.intersection(userStates).size > 0) {
      return true;
    }

    if (sessionCountry == "IT" && userStates.has("New York")) {
      return true;
    }

    if (sessionCountry == "IT" && userCountries.has("BM")) {
      return true;
    }
  }
  return false;
};

export default isGroupVisaEligible;
